module.exports = __webpack_public_path__ + "static/mail_qq-7625e05b7a7a7acf44b2daa70fcabd38.png";